import { ENDPOINTS } from '@/settings/api-settings';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from './api';
import { ResultPagDTO } from '@/interfaces/base-dto';
import { RestricaoFiltroPagDTO, RestricaoHierarquiaFiltroPagDTO, RestricaoParmDTO } from '@/interfaces/rules-engine';

export function findByFilter(filter: RestricaoFiltroPagDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(ENDPOINTS.RULES_ENGINE, filter)).pipe(
    map((r: any) => (!!r ? r.data : [])),
  );
}

function saveRule(payload: RestricaoParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.RULES_ENGINE, payload)).pipe(
    map((r: any) => r.data),
  );
}

function updateRule(payload: RestricaoParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.RULES_ENGINE, payload)).pipe(
    map((r: any) => r.data),
  );
}

function getRule(id: string): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.RULES_ENGINE}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}

function deleteRule(id: string): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.RULES_ENGINE}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}

export function updateStatusRule(id: string, newStatus:boolean): Observable<any> {
  let url = `${ENDPOINTS.RULES_ENGINE_STATUS.replace("{id}", id)}/${newStatus}`;
  return from(apiClient.put(url, null)).pipe(
    map((r: any) => r.data),
  );
}

function listConditions(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.RULES_ENGINE_CONDITIONS)).pipe(
    map((r: any) => r.data),
  );
}

function configurableEntity(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.RULES_ENGINE_ENTITY)).pipe(
    map((r: any) => r.data),
  );
}

function operators(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.RULES_ENGINE_OPERATORS)).pipe(
    map((r: any) => r.data),
  );
}

export function listRulesOverrides(filter: RestricaoHierarquiaFiltroPagDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(ENDPOINTS.RULES_ENGINE_OVERRIDE, filter)).pipe(
    map((r: any) => (!!r ? r.data : [])),
  );
}

function getRuleOverride(id: string): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.RULES_ENGINE}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}

function saveRuleOverride(payload: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.RULES_ENGINE_OVERRIDE, payload)).pipe(
    map((r: any) => r.data),
  );
}

function updateRuleOverride(payload: any): Observable<any> {
  return from(apiClient.put(ENDPOINTS.RULES_ENGINE_OVERRIDE, payload)).pipe(
    map((r: any) => r.data),
  );
}

function deleteRuleOverride(id: string): Observable<any> {
  return from(apiClient.delete(ENDPOINTS.RULES_ENGINE_OVERRIDE, { id })).pipe(
    map((r: any) => r.data),
  );
}

export function listRuleAlterHist(id: number): Observable<any> {
  return from(apiClient.get(ENDPOINTS.RULES_ENGINE_ALTER_HIST.replace('{id}', id.toString()))).pipe(
    map((r: any) => r.data),
  );
}

export {
  configurableEntity, deleteRule, deleteRuleOverride, getRule, getRuleOverride, listConditions, operators, saveRule, saveRuleOverride, updateRule, updateRuleOverride
};

